import { render, staticRenderFns } from "./equipDetail.vue?vue&type=template&id=3f6661d8&scoped=true"
import script from "./equipDetail.vue?vue&type=script&lang=js"
export * from "./equipDetail.vue?vue&type=script&lang=js"
import style0 from "./equipDetail.vue?vue&type=style&index=0&id=3f6661d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6661d8",
  null
  
)

export default component.exports